import { IApp } from 'types.d';
import axios from 'axios';
import {
  ExternalAppStrategy,
  IFrameDocStrategy,
  IFrameSrcStrategy,
  NewPageStrategy,
  SamePageStrategy,
} from 'lib/launchStrategies/launchStrategies';
import {
  HREF,
  IFRAME_ID,
  IFRAME_SRCDOC,
  NEW_TAB,
  SAME_TAB,
  SAME_WINDOW,
  SANDBOX,
} from 'lib/config';
import { errorGenerator } from 'lib/errorGenerator';
import { generatoreCode } from 'lib/generateCode';
import { TITLE_BASE } from 'providers/InitProvider';
import { ensureUrlEndsWithIndexHtml } from 'lib/strings';

// let currentAppUri = '';

const isMobileClient = function(): boolean {
  const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return regex.test(navigator.userAgent);
}

/**
 * select the strategy base on dump data
 *
 * @returns a Strategy implementation
 */
export function selectStrategy({ data, token }: { data: IApp; token: string }) {
  const isPwaInstalled = window.matchMedia('(display-mode: standalone)').matches;
  const isMobile = isMobileClient();
  console.log(`
Select launch strategy for ${data.code}
 - token=${token}
 - isPwaInstalled=${isPwaInstalled}
 - isMobile=${isMobile}
  `)
  console.log(`Select strategy for data: ${data?.target} ${data?.integrationMode}`)
  const integrationMode = (data.integrationMode ?? '').toLowerCase();
  const target = (data.target ?? '').toLowerCase();
  if (integrationMode === HREF) {
    console.log('Integration mode HREF: ExternalAppStrategy');
    return new ExternalAppStrategy(token);
  }
  // FIXME !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  // FIXME: DOVREBBE ESSERE ISPWA MA PER TEST CONSIDERIAMO ISMOBILE!
  // FIXME !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  if (isMobile && target === NEW_TAB) {
    console.log('PWA + target new tab: SamePageStrategy');
    return new SamePageStrategy();
  }
  if (target === SAME_TAB || target === SAME_WINDOW) {
    console.log(`target SAME_TAB || SAME_WINDOW: IFRAME ${data.integrationMode}`);
    // Default: iframe con src (evita about:srcdoc e document URL non-HTTP).
    // srcdoc + prefetch solo se il backend invia integrationMode esplicito iframe-srcdoc.
    return integrationMode === IFRAME_SRCDOC
      ? new IFrameDocStrategy(token)
      : new IFrameSrcStrategy(token);
  }
  if (target === NEW_TAB) {
    console.log('Target NEW TAB: NewPageStrategy');
    return new NewPageStrategy();
  }
  throw new Error(
    `strategy not implemented - integration mode "${data.integrationMode}", target "${data.target}"`,
  );
}

function uriWithTokenParam(uri: string): string {
  // const rqxSsoToken = localStorage.getItem(SSO_LOCAL_STORAGE_KEY_TOKEN);
  return uri; // + '?token=' + rqxSsoToken;
}

/**
 * Remove and recreate the iframe to host the applicatione
 * @param data
 */
export function createFrame(data: IApp) {
  let el = document.querySelector(`#${IFRAME_ID}`);
  if (el) {
    removeAppFrame();
  }
  // update hash value
  console.log(`[createFrame] data before updating hash:
label="${data.label}"
code="${data.code}"
deeplinkdetails="${data.deepLinkDetails}"`)
  data.label && data.code && updateHash(data.label, data.code);

  el = document.createElement('iframe');
  el.id = IFRAME_ID;
  el.classList.add(IFRAME_ID);
  el['sandbox'] = SANDBOX;
  // Aggiunge i permessi per la clipboard
  el.setAttribute('allow', 'clipboard-read; clipboard-write');
  if (data.srcdoc) {
    el['srcdoc'] = data.srcdoc;
    // el.dataset.contenttype = 'doc'
  } else {
    /*

    src deve essere valorizzata con intero contenuto del path (per permettere deep link in applicazione)
    
    */
    const uwtp = uriWithTokenParam(data.uri);
    console.log(`Create frame data.uri="${data.uri}" uwtp="${uwtp}"`)
    el['src'] = uwtp;
    // el.dataset.contenttype = 'url'
  }
  document.querySelector('body').appendChild(el);
}

export function resolveUrl(path = '') {
  if (path.startsWith('http')) {
    return path;
  }
  const baseUrl = getBaseUrl();
  return `${baseUrl}/${path}`;
}

export function getBaseUrl() {
  const { host, protocol } = window.location;
  return `${protocol}//${host}`;
}

export async function startRequest(config, token) {
  try {
    const result = await axios(
      Object.assign({}, config, {
        withCredentials: true,
        // headers: {
        //   Authorization: `Bearer ${token}`,
        //   //'Access-Control-Allow-Origin': '*'
        // },
      }),
    );
    console.log('start request result  ', result);
    return result.data;
  } catch (error) {
    const errorCode = generatoreCode(8).toString();
    errorGenerator(
      errorCode,
      error,
      'startRequest failure',
      'Tentativo di far partire l applicativo all interno dell iframe',
    );
    return `<html><body>${error.message}</body></html>`;
  }
}

function removeAppFrame() {
  removeHash();
  var el = document.querySelector(`#${IFRAME_ID}`);
  if (el) document.querySelector('body').removeChild(el);
}

export function updateHash(rawTitle, rawHash) {
  const title = rawTitle ? rawTitle.charAt(0).toUpperCase() + rawTitle.slice(1) : '';
  const hash = rawHash ? rawHash.toLowerCase() : '';
  console.log(`updateHash "${title}" set hash="${hash}" on "${window.location.href}"`)
  if (hash === 'dashboard' && window.location.href.endsWith('?')) {
    const locationHref = window.location.href.slice(0, -1);
    window.location.href = ensureUrlEndsWithIndexHtml(locationHref);
    console.log(`Edited href to "${window.location.href}"`)
  }
  if (hash === 'dashboard' && window.location.search) {
    console.log(`updateHash location.search="${window.location.search}"`)
    // remove query params
    const urlWithoutSearch = window.location.href.split('?')[0];
    window.location.search = '';
    // window.location.href = ensureUrlEndsWithIndexHtml(urlWithoutSearch);
    window.history.replaceState({}, document.title, ensureUrlEndsWithIndexHtml(urlWithoutSearch));
    console.log(`updateHash after search unset, urlWithoutSearch="${urlWithoutSearch}" location.href="${window.location.href}"`)
  }
  let currentHash = window.location.hash;
  currentHash = currentHash?.startsWith('#') ? currentHash.substring(1) : currentHash;
  console.log(`updateHash hash before change="${currentHash}"`);
  if (currentHash?.startsWith(`${hash}/`)) {
    // deep link: hash nel formato "appcode/parametri"
    console.log(`updateHash deep link detected: current hash starts with "${hash}" + "/"`);
    const deepLinkDetails = resolveDeepLinkDetails(currentHash);
    console.log(`updateHash deepLinkDetails="${deepLinkDetails}"`);
  }
  window.location.hash = hash;
  console.log(`updateHash window.location="${window.location}"`);
  (window as any).rqxTools.setCurrentAppUri();
  hash === 'dashboard' || hash === 'workspace'
    ? (document.title = `${TITLE_BASE} - ${title}`)
    : (document.title = title);
}

export function resolveDeepLinkDetails(input: string) {
  // Verifica se l'input e' una stringa non vuota
  if (!input || typeof input !== 'string') {
    return null;
  }
  // Trova l'indice del primo carattere "/"
  const slashIndex = input.indexOf('/');
  // Se non presente alcun "/", restituisci null
  if (slashIndex === -1) {
    return null;
  }
  // Estrai la substring dopo il primo "/"
  return input.substring(slashIndex + 1);
}

function removeHash() {
  // window.alert('removeHash');
  var uri = window.location.toString();
  var position = uri.indexOf('#');
  if (position > 0) {
    var newUri = uri.substring(0, position);
    window.history.replaceState({}, document.title, newUri);
  }
}
